import { useWindowSize } from '@Components/Utilities/WindowSize';

const SearchContainer = (props) => {
    const windowSize = useWindowSize();
    const {
        handleSearch,
        handleQuickSearchClear,
        searchTerm,
        setSearchTerm,
        minPrice,
        setMinPrice,
        maxPrice,
        setMaxPrice
    } = props;

    return (
        <div className="side-container" style={{ marginInline: '1%', width: '20%' }}>
                <div id="filters" className="faceted-search-content no-print mobile-visible">
                    {windowSize.isMobile &&
                        <div class="mobile-done-button-container">
                            <a class="mobile-done-button" role="button" tabindex="0" onClick={props.toggleMobileFilters}>
                                <span>Done</span>
                            </a>
                        </div>}
                    <div className="faceted-search__main-section" id="faceted-search-main">
                        <div className="faceted-search-field Text">
                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                <button className="ts-button faceted-section-head section-head " aria-expanded="true">
                                    <div className="faceted-section-title">
                                        <span>Quick Search</span>
                                    </div>

                                </button>
                                {searchTerm.trim() != '' &&
                                    <button
                                        type="button"
                                        style={{ backgroundColor: '#f6f6f6', color: 'black', textDecoration: 'underline', borderBottom: '1px solid #ddd' }}
                                        onClick={handleQuickSearchClear}
                                        tabIndex={0}
                                        onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); handleQuickSearchClear(); } }}
                                        disabled={!searchTerm.trim()}
                                    >
                                        <span><span>Clear</span></span>
                                    </button>}
                            </div>
                            <fieldset className="ts__fieldset">
                                <legend class="visually-hidden ts__legend">keywords</legend>
                                <div class="faceted-section-box"><div>
                                    <label for="list-search-autocomp-keywords" class="visually-hidden">Enter Keyword(s)</label>
                                    <div>
                                    <input type="text"
                                        aria-required="false"
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        aria-invalid="false"
                                        class="faceted-text-input ui-autocomplete-input"
                                        value={searchTerm}
                                        placeholder="Enter Keyword(s)"
                                        name="keywords"
                                        id="list-search-autocomp-keywords"
                                        min="0"
                                        autocomplete="off" 
                                        onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); handleSearch({ target: { value: searchTerm } }); } }} />
                                    </div>
                                    <button
                                        type="submit"
                                        className="ts-button faceted-search"
                                        onClick={() => handleSearch({ target: { value: searchTerm } })}
                                    >
                                        <span>
                                            <span>Search</span>
                                        </span>
                                    </button>
                                </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                </div>
        </div>
    )
    
};

export default SearchContainer;

